import { ConvertersType } from 'common/types/ConvertersType'
import { KeysConvertType } from 'common/types/KeysConvertType'
import { KeysConvert } from './KeysConvert'

class ConvertersClass implements ConvertersType {
  KeysConvert: KeysConvertType

  constructor(keysConvert: KeysConvertType) {
    this.KeysConvert = keysConvert
  }
}

const keys = new KeysConvert()
export const Converters = new ConvertersClass(keys)
